import { useRpQuery } from '~/composables/graphql'
import { useMutation } from '@tanstack/vue-query'
import type { SignDocumentInput } from '~/resources/graphql/graphql'
import { graphql } from '~/resources/graphql'
import { useSelectedLanguage } from '~/composables/use-selected-language'

// Update the contract with the completed document information
export function useSignDocumentMutation() {
    const query = useRpQuery()
    const selectedLanguage = useSelectedLanguage()
    return useMutation({
        mutationFn: async (mutationData: {
            input: SignDocumentInput
            facilityId: string
        }) => {
            const response = await query(
                graphql(/** @lang GraphQL */ `
                    mutation CompleteDocument(
                        $input: SignDocumentInput!
                        $facilityId: ID!
                        $language: Language!
                    ) {
                        signDocument(input: $input) {
                            __typename
                            ... on SignDocumentResult {
                                recordId
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...AnalyticsAddToCartResultFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                            ... on ValidationError {
                                fieldErrors {
                                    path
                                    message
                                }
                            }
                        }
                    }
                `),
                {
                    ...mutationData,
                    language: selectedLanguage.value
                }
            )

            return response.signDocument
        }
    })
}
